export class FieldModel {
    public constructor(public type: "X" | "O" | " " = " ") {

    }
}